(function () {
  var API_URL = 'https://zahav-chatbot.vercel.app/api/chat';

  var messages = [];

  var productHandle = null;
  var bodyEl = document.body;
  if (bodyEl && bodyEl.classList.contains('template-product')) {
    var canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      var m = canonical.getAttribute('href').match(/\/products\/([\w-]+)/);
      if (m) productHandle = m[1];
    }
  }

  var css = [
    '#zahav-chat-btn {',
    '  position: fixed; bottom: 28px; right: 28px; z-index: 200;',
    '  width: 54px; height: 54px; border-radius: 50%;',
    '  background: #2C2C2C; border: none; cursor: pointer;',
    '  display: flex; align-items: center; justify-content: center;',
    '  box-shadow: 0 4px 20px rgba(0,0,0,0.18);',
    '  transition: background 0.2s, transform 0.2s;',
    '}',
    '#zahav-chat-btn:hover { background: #C9A96E; transform: scale(1.06); }',
    '#zahav-chat-btn svg { width: 24px; height: 24px; }',

    '#zahav-chat-panel {',
    '  position: fixed; bottom: 94px; right: 28px; z-index: 9999;',
    '  width: 360px; max-width: calc(100vw - 40px);',
    '  height: 520px; max-height: calc(100vh - 120px);',
    '  background: #FAF8F6; border-radius: 16px;',
    '  box-shadow: 0 8px 40px rgba(0,0,0,0.14);',
    '  display: flex; flex-direction: column; overflow: hidden;',
    '  opacity: 0; pointer-events: none; transform: translateY(12px);',
    '  transition: opacity 0.22s ease, transform 0.22s ease;',
    '}',
    '#zahav-chat-panel.zahav-chat--open {',
    '  opacity: 1; pointer-events: all; transform: translateY(0);',
    '}',

    '.zahav-chat__header {',
    '  background: #2C2C2C; color: #FAF8F6;',
    '  padding: 16px 20px; display: flex; align-items: center; gap: 10px; flex-shrink: 0;',
    '}',
    '.zahav-chat__header-icon {',
    '  width: 32px; height: 32px; border-radius: 50%; background: #C9A96E;',
    '  display: flex; align-items: center; justify-content: center; flex-shrink: 0;',
    '}',
    '.zahav-chat__header-icon svg { width: 16px; height: 16px; }',
    '.zahav-chat__header-text { flex: 1; }',
    '.zahav-chat__header-name {',
    '  font-family: "Ivy Presto Display", Georgia, serif;',
    '  font-size: 0.95rem; font-weight: 300; letter-spacing: 0.02em; display: block;',
    '}',
    '.zahav-chat__header-status {',
    '  font-family: "Jost", Verdana, sans-serif;',
    '  font-size: 0.62rem; letter-spacing: 0.12em; text-transform: uppercase;',
    '  color: #C9A96E; display: block; margin-top: 1px;',
    '}',
    '.zahav-chat__close {',
    '  background: none; border: none; cursor: pointer; color: #9A8F83;',
    '  padding: 4px; display: flex; align-items: center; justify-content: center;',
    '  transition: color 0.2s;',
    '}',
    '.zahav-chat__close:hover { color: #FAF8F6; }',
    '.zahav-chat__close svg { width: 18px; height: 18px; }',

    '.zahav-chat__messages {',
    '  flex: 1; overflow-y: auto; padding: 20px 16px;',
    '  display: flex; flex-direction: column; gap: 12px; scroll-behavior: smooth;',
    '}',
    '.zahav-chat__messages::-webkit-scrollbar { width: 4px; }',
    '.zahav-chat__messages::-webkit-scrollbar-track { background: transparent; }',
    '.zahav-chat__messages::-webkit-scrollbar-thumb { background: #E8E2DA; border-radius: 2px; }',

    '.zahav-chat__bubble {',
    '  max-width: 82%; padding: 10px 14px; border-radius: 12px;',
    '  font-family: "Jost", Verdana, sans-serif;',
    '  font-size: 0.82rem; line-height: 1.65; word-break: break-word;',
    '}',
    '.zahav-chat__bubble--assistant {',
    '  background: #fff; color: #2C2C2C;',
    '  border: 1px solid #E8E2DA; align-self: flex-start; border-bottom-left-radius: 3px;',
    '}',
    '.zahav-chat__bubble--user {',
    '  background: #2C2C2C; color: #FAF8F6;',
    '  align-self: flex-end; border-bottom-right-radius: 3px;',
    '}',

    '.zahav-chat__typing {',
    '  display: flex; align-items: center; gap: 4px; padding: 10px 14px;',
    '  background: #fff; border: 1px solid #E8E2DA;',
    '  border-radius: 12px; border-bottom-left-radius: 3px; align-self: flex-start;',
    '}',
    '.zahav-chat__typing span {',
    '  width: 6px; height: 6px; background: #C9A96E; border-radius: 50%;',
    '  animation: zahav-chat-bounce 1.2s ease-in-out infinite;',
    '}',
    '.zahav-chat__typing span:nth-child(2) { animation-delay: 0.2s; }',
    '.zahav-chat__typing span:nth-child(3) { animation-delay: 0.4s; }',
    '@keyframes zahav-chat-bounce {',
    '  0%, 60%, 100% { transform: translateY(0); opacity: 0.4; }',
    '  30% { transform: translateY(-5px); opacity: 1; }',
    '}',

    '.zahav-chat__footer {',
    '  padding: 12px 16px; border-top: 1px solid #E8E2DA;',
    '  display: flex; gap: 8px; flex-shrink: 0; background: #FAF8F6;',
    '}',
    '.zahav-chat__input {',
    '  flex: 1; border: 1px solid #E8E2DA; border-radius: 8px;',
    '  padding: 9px 12px; font-family: "Jost", Verdana, sans-serif;',
    '  font-size: 16px; color: #2C2C2C; background: #fff;',
    '  outline: none; resize: none; line-height: 1.4; max-height: 80px;',
    '  transition: border-color 0.2s;',
    '}',
    '@media (min-width: 480px) {',
    '  .zahav-chat__input { font-size: 0.82rem; }',
    '}',
    '.zahav-chat__input:focus { border-color: #C9A96E; }',
    '.zahav-chat__input::placeholder { color: #9A8F83; }',
    '.zahav-chat__send {',
    '  width: 36px; height: 36px; border-radius: 8px; background: #2C2C2C;',
    '  border: none; cursor: pointer; display: flex; align-items: center;',
    '  justify-content: center; flex-shrink: 0; align-self: flex-end;',
    '  transition: background 0.2s;',
    '}',
    '.zahav-chat__send:hover { background: #C9A96E; }',
    '.zahav-chat__send:disabled { background: #E8E2DA; cursor: not-allowed; }',
    '.zahav-chat__send svg { width: 16px; height: 16px; color: #FAF8F6; }',

    '.zahav-chat__disclaimer {',
    '  text-align: center; font-family: "Jost", Verdana, sans-serif;',
    '  font-size: 0.58rem; letter-spacing: 0.06em; color: #9A8F83;',
    '  padding: 0 16px 10px; background: #FAF8F6;',
    '}'
  ].join('\n');

  var style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  var btn = document.createElement('button');
  btn.id = 'zahav-chat-btn';
  btn.setAttribute('aria-label', 'Chat with us');
  btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="#FAF8F6" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>';
  document.body.appendChild(btn);

  var panel = document.createElement('div');
  panel.id = 'zahav-chat-panel';
  panel.setAttribute('role', 'dialog');
  panel.setAttribute('aria-label', 'Zahav support chat');
  panel.innerHTML = '<div class="zahav-chat__header">'
    + '<div class="zahav-chat__header-icon"><svg viewBox="0 0 24 24" fill="none" stroke="#FAF8F6" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="8" r="4"/><path d="M4 20c0-4 3.6-7 8-7s8 3 8 7"/></svg></div>'
    + '<div class="zahav-chat__header-text"><span class="zahav-chat__header-name">Zahav Support</span><span class="zahav-chat__header-status">Online · Here to help</span></div>'
    + '<button class="zahav-chat__close" aria-label="Close chat"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></button>'
    + '</div>'
    + '<div class="zahav-chat__messages" id="zahav-chat-messages"></div>'
    + '<div class="zahav-chat__footer">'
    + '<textarea class="zahav-chat__input" id="zahav-chat-input" placeholder="Ask us anything..." rows="1" aria-label="Message"></textarea>'
    + '<button class="zahav-chat__send" id="zahav-chat-send" aria-label="Send"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg></button>'
    + '</div>'
    + '<p class="zahav-chat__disclaimer">Powered by AI · For order help, <a href="/pages/contact" style="color:#C9A96E;text-decoration:none;">contact us</a></p>';
  document.body.appendChild(panel);

  var messagesEl = document.getElementById('zahav-chat-messages');
  var inputEl = document.getElementById('zahav-chat-input');
  var sendBtn = document.getElementById('zahav-chat-send');
  var isOpen = false;

  function renderText(text) {
    var s = text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    s = s.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
    s = s.replace(/^(\d+)\.\s+/gm, '<span style="color:#C9A96E;font-weight:600;margin-right:4px;">$1.</span> ');
    s = s.replace(/^[-•]\s+/gm, '<span style="color:#C9A96E;margin-right:6px;">—</span>');
    s = s.replace(/\n/g, '<br>');
    return s;
  }

  function addMessage(role, text) {
    var bubble = document.createElement('div');
    bubble.className = 'zahav-chat__bubble zahav-chat__bubble--' + role;
    if (role === 'assistant') {
      bubble.innerHTML = renderText(text);
    } else {
      bubble.textContent = text;
    }
    messagesEl.appendChild(bubble);
    messagesEl.scrollTop = messagesEl.scrollHeight;
    return bubble;
  }

  function trySubmitContact(assistantText) {
    var emailMatch = assistantText.match(/\b[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}\b/);
    if (!emailMatch) return;

    var transcript = messages.map(function (msg) {
      return (msg.role === 'user' ? 'Customer' : 'Zahav') + ': ' + msg.content;
    }).join('\n');

    var email = emailMatch[0];
    var nameLine = messages.find(function (msg, idx) {
      return msg.role === 'user' && msg.content.length < 80 && idx > 0;
    });
    var name = nameLine ? nameLine.content : 'Chat Customer';

    fetch('https://zahav-chatbot.vercel.app/api/contact', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ name: name, email: email, message: 'Customer contacted support via chat widget.', transcript: transcript }),
    }).catch(function () {});
  }

  function showTyping() {
    var el = document.createElement('div');
    el.className = 'zahav-chat__typing';
    el.id = 'zahav-chat-typing';
    el.innerHTML = '<span></span><span></span><span></span>';
    messagesEl.appendChild(el);
    messagesEl.scrollTop = messagesEl.scrollHeight;
  }

  function hideTyping() {
    var el = document.getElementById('zahav-chat-typing');
    if (el) el.remove();
  }

  function openPanel() {
    isOpen = true;
    panel.classList.add('zahav-chat--open');
    btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="#FAF8F6" stroke-width="2" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
    if (messages.length === 0) {
      addMessage('assistant', 'Hi! I’m here to help you find the perfect piece. Ask me anything about our gold jewelry, piercing types, or care tips.');
    }
    setTimeout(function () { inputEl.focus(); }, 250);
  }

  function closePanel() {
    isOpen = false;
    panel.classList.remove('zahav-chat--open');
    btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="#FAF8F6" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>';
  }

  btn.addEventListener('click', function () { if (isOpen) { closePanel(); } else { openPanel(); } });
  panel.querySelector('.zahav-chat__close').addEventListener('click', closePanel);

  function sendMessage() {
    var text = inputEl.value.trim();
    if (!text) return;

    inputEl.value = '';
    inputEl.style.height = 'auto';
    sendBtn.disabled = true;

    messages.push({ role: 'user', content: text });
    addMessage('user', text);
    showTyping();

    fetch(API_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ messages: messages, productHandle: productHandle }),
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        hideTyping();
        var reply = data.reply || 'Sorry, I could not get a response. Please try again.';
        messages.push({ role: 'assistant', content: reply });
        addMessage('assistant', reply);
        trySubmitContact(reply);
      })
      .catch(function () {
        hideTyping();
        addMessage('assistant', 'Something went wrong. Please try again or contact us directly.');
      })
      .finally(function () {
        sendBtn.disabled = false;
        inputEl.focus();
      });
  }

  sendBtn.addEventListener('click', sendMessage);

  inputEl.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      sendMessage();
    }
  });

  inputEl.addEventListener('input', function () {
    this.style.height = 'auto';
    this.style.height = Math.min(this.scrollHeight, 80) + 'px';
  });
})();
